import { injectable, injectFromBase } from 'inversify';
import type { AxiosResponse } from 'axios';
import { BaseApiService } from '@kiplin/web-common/architecture-core';

@injectable()
@injectFromBase()
// Used for cockpit calls that must NOT inherit the JWT interceptor from AbstractCockpitApiService
// (e.g. downloading public assets/blobs). Keeps BaseApiService usage without auth coupling.
export class PublicCockpitApiService extends BaseApiService {
  public downloadFile(url: string): Promise<AxiosResponse<Blob>> {
    return this.get<Blob>(url, { responseType: 'blob' });
  }
}
